import React from 'react'
import TodayTasks from "./TodayTasks"

const UpcomingTasks = () => {
  return (
    <div>
      <TodayTasks />
    </div>
  )
}

export default UpcomingTasks
